// Mirrors backend constants.py — keep in sync.
import {
  CreditCard,
  Zap,
  Flame,
  Droplet,
  Smartphone,
  Tv,
  Wifi,
  Banknote,
  HeartPulse,
  Car,
} from "lucide-react";

export const BBPS_CATEGORIES = [
  { id: "credit-card", label: "Credit Card", icon: CreditCard, highlight: true, placeholder: "16-digit card number / registered mobile", featureKey: "bbps_credit_card" },
  { id: "electricity", label: "Electricity", icon: Zap, placeholder: "Consumer number", featureKey: "bbps_electricity" },
  { id: "gas", label: "Gas", icon: Flame, placeholder: "CA number / consumer number", featureKey: "bbps_gas" },
  { id: "water", label: "Water", icon: Droplet, placeholder: "RR / consumer number", featureKey: "bbps_water" },
  { id: "mobile-postpaid", label: "Mobile Postpaid", icon: Smartphone, placeholder: "Mobile number", featureKey: "bbps_mobile_postpaid" },
  { id: "mobile-prepaid", label: "Mobile Prepaid", icon: Smartphone, placeholder: "Mobile number", featureKey: "bbps_mobile_prepaid" },
  { id: "dth", label: "DTH", icon: Tv, placeholder: "Subscriber ID", featureKey: "bbps_dth" },
  { id: "broadband", label: "Broadband", icon: Wifi, placeholder: "Account / subscriber ID", featureKey: "bbps_broadband" },
  { id: "loan-emi", label: "Loan EMI", icon: Banknote, placeholder: "Loan account number", featureKey: "bbps_loan_emi" },
  { id: "insurance", label: "Insurance", icon: HeartPulse, placeholder: "Policy number", featureKey: "bbps_insurance" },
  { id: "fastag", label: "FASTag", icon: Car, placeholder: "Vehicle / tag ID", featureKey: "bbps_fastag" },
];

export const CATEGORY_LABEL = Object.fromEntries(BBPS_CATEGORIES.map((c) => [c.id, c.label]));
export const CATEGORY_ICON = Object.fromEntries(BBPS_CATEGORIES.map((c) => [c.id, c.icon]));

export const PAYOUT_RAILS = [
  { id: "upi", label: "UPI", min: 1, max: 100000, beneficiary_type: "upi", hint: "Instant · 24×7" },
  { id: "imps", label: "IMPS", min: 1, max: 500000, beneficiary_type: "bank", hint: "Instant · 24×7" },
  { id: "neft", label: "NEFT", min: 1, max: 2000000, beneficiary_type: "bank", hint: "Batched · bank hours" },
  { id: "rtgs", label: "RTGS", min: 200000, max: 10000000, beneficiary_type: "bank", hint: "High-value · bank hours" },
];

export const RAIL_LABEL = Object.fromEntries(PAYOUT_RAILS.map((r) => [r.id, r.label]));

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(Number(n || 0));
